export class DsgMetadata {
  public static value = {
    structuralTypes: [
      {
        shortName: 'PbiRefreshMessage',
        namespace: 'DataServicesGateway.Shared.Model',
        isComplexType: true,
        dataProperties: [
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 200,
            nameOnServer: 'Code',
            validators: [{ maxLength: 200, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'Message',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 50,
            nameOnServer: 'Type',
            validators: [{ maxLength: 50, name: 'maxLength' }]
          }
        ],
        navigationProperties: []
      },
      {
        shortName: 'BusinessTransactionLock',
        namespace: 'DataServicesGateway.Shared.Data',
        autoGeneratedKeyType: 'None',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'String',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Key',
            validators: [{ name: 'required' }]
          },
          { dataType: 'DateTime', isNullable: true, nameOnServer: 'Expiry', validators: [{ name: 'date' }] }
        ],
        navigationProperties: []
      },
      {
        shortName: 'Bookmark',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'Bookmarks',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDefault',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'NeedsReview',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'ReportId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          { dataType: 'String', isNullable: false, nameOnServer: 'State', validators: [{ name: 'required' }] },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName: 'DataServicesGateway.Shared.Model.Bookmark_DataServicesGateway.Shared.Model.Report_Report',
            foreignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'Report',
            validators: []
          }
        ]
      },
      {
        shortName: 'DataRefresh',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'DataRefreshes',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'AcceptedAt',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 200,
            nameOnServer: 'OrchestratorInstanceId',
            validators: [{ maxLength: 200, name: 'maxLength' }]
          },
          { dataType: 'DateTime', isNullable: true, nameOnServer: 'SettledAt', validators: [{ name: 'date' }] },
          { dataType: 'DateTime', isNullable: true, nameOnServer: 'StartedAt', validators: [{ name: 'date' }] },
          {
            dataType: 'String',
            enumType: 'DataRefreshStatus:#DataServicesGateway.Shared.Model',
            isNullable: false,
            maxLength: 50,
            nameOnServer: 'Status',
            validators: [{ name: 'required' }, { maxLength: 50, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            enumType: 'DataRefreshTriggerSource:#DataServicesGateway.Shared.Model',
            isNullable: false,
            maxLength: 50,
            nameOnServer: 'TriggerSource',
            validators: [{ name: 'required' }, { maxLength: 50, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'PbiDatasetRefresh:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.PbiDatasetRefresh_DataServicesGateway.Shared.Model.DataRefresh_DataRefresh',
            invForeignKeyNamesOnServer: ['DataRefreshId'],
            nameOnServer: 'DatasetRefreshes',
            validators: []
          }
        ]
      },
      {
        shortName: 'Dataset',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'Datasets',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'Category',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'HasStandardRlsRoles',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsFromClientTemplate',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'DateTime',
            isNullable: true,
            nameOnServer: 'LastSuccessfulRefreshAt',
            validators: [{ name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'ModuleName',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'OrganisationWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'Region',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'TemplateDatasetName',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'DatasetAccess:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.DatasetAccess_DataServicesGateway.Shared.Model.Dataset_Target',
            invForeignKeyNamesOnServer: ['TargetId'],
            nameOnServer: 'AllowedPrincipals',
            validators: []
          },
          {
            entityTypeName: 'OrganisationWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.Dataset_DataServicesGateway.Shared.Model.OrganisationWorkspace_OrganisationWorkspace',
            foreignKeyNamesOnServer: ['OrganisationWorkspaceId'],
            nameOnServer: 'OrganisationWorkspace',
            validators: []
          },
          {
            entityTypeName: 'PbiDataset:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.PbiDataset_DataServicesGateway.Shared.Model.Dataset_Dataset',
            invForeignKeyNamesOnServer: ['DatasetId'],
            nameOnServer: 'PbiDatasets',
            validators: []
          },
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName: 'DataServicesGateway.Shared.Model.Report_DataServicesGateway.Shared.Model.Dataset_Dataset',
            invForeignKeyNamesOnServer: ['DatasetId'],
            nameOnServer: 'Reports',
            validators: []
          }
        ]
      },
      {
        shortName: 'DatasetAccess',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'DatasetAccesses',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'TargetId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'IdentityPrincipalId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.DatasetAccess_DataServicesGateway.Shared.Model.IdentityPrincipal_IdentityPrincipal',
            foreignKeyNamesOnServer: ['IdentityPrincipalId'],
            nameOnServer: 'IdentityPrincipal',
            validators: []
          },
          {
            entityTypeName: 'Dataset:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.DatasetAccess_DataServicesGateway.Shared.Model.Dataset_Target',
            foreignKeyNamesOnServer: ['TargetId'],
            nameOnServer: 'Target',
            validators: []
          }
        ]
      },
      {
        shortName: 'DraftBookmark',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'DraftBookmarks',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'DraftId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsCopy',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDefault',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'ParentBookmarkId', validators: [{ name: 'guid' }] },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'ParentLastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          { dataType: 'String', isNullable: false, nameOnServer: 'State', validators: [{ name: 'required' }] },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'PbiReport:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.DraftBookmark_DataServicesGateway.Shared.Model.PbiReport_Draft',
            foreignKeyNamesOnServer: ['DraftId'],
            nameOnServer: 'Draft',
            validators: []
          },
          {
            entityTypeName: 'Bookmark:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.DraftBookmark_DataServicesGateway.Shared.Model.Bookmark_ParentBookmark',
            foreignKeyNamesOnServer: ['ParentBookmarkId'],
            nameOnServer: 'ParentBookmark',
            validators: []
          }
        ]
      },
      {
        shortName: 'ForgottenUser',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'ForgottenUsers',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'UserId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          }
        ],
        navigationProperties: []
      },
      {
        shortName: 'GroupMembership',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'GroupMemberships',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'MemberId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'GroupId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'GroupPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.GroupMembership_DataServicesGateway.Shared.Model.GroupPrincipal_Group',
            foreignKeyNamesOnServer: ['GroupId'],
            nameOnServer: 'Group',
            validators: []
          },
          {
            entityTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.GroupMembership_DataServicesGateway.Shared.Model.IdentityPrincipal_Member',
            foreignKeyNamesOnServer: ['MemberId'],
            nameOnServer: 'Member',
            validators: []
          }
        ]
      },
      {
        shortName: 'GroupPrincipal',
        namespace: 'DataServicesGateway.Shared.Model',
        baseTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'Groups',
        isComplexType: false,
        dataProperties: [],
        navigationProperties: [
          {
            entityTypeName: 'GroupMembership:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.GroupMembership_DataServicesGateway.Shared.Model.GroupPrincipal_Group',
            invForeignKeyNamesOnServer: ['GroupId'],
            nameOnServer: 'Members',
            validators: []
          }
        ]
      },
      {
        shortName: 'IdentityPrincipal',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        isAbstract: true,
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 100,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 100, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 30,
            nameOnServer: 'Type',
            validators: [{ name: 'required' }, { maxLength: 30, name: 'maxLength' }]
          }
        ],
        navigationProperties: []
      },
      {
        shortName: 'OrganisationMembership',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'OrganisationMemberships',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'UserId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'OrganisationId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'OrganisationPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationMembership_DataServicesGateway.Shared.Model.OrganisationPrincipal_Organisation',
            foreignKeyNamesOnServer: ['OrganisationId'],
            nameOnServer: 'Organisation',
            validators: []
          },
          {
            entityTypeName: 'UserPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationMembership_DataServicesGateway.Shared.Model.UserPrincipal_User',
            foreignKeyNamesOnServer: ['UserId'],
            nameOnServer: 'User',
            validators: []
          }
        ]
      },
      {
        shortName: 'OrganisationPrincipal',
        namespace: 'DataServicesGateway.Shared.Model',
        baseTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'Organisations',
        isComplexType: false,
        dataProperties: [
          { dataType: 'Guid', isNullable: true, nameOnServer: 'DefaultRoleId', validators: [{ name: 'guid' }] },
          {
            dataType: 'Collections.Generic.List`1[String]',
            isNullable: false,
            nameOnServer: 'DomainNames',
            validators: [{ name: 'required' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsLinkedToAgoraGatewayAppTile',
            validators: [{ name: 'required' }, { name: 'bool' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'Role:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationPrincipal_DataServicesGateway.Shared.Model.Role_DefaultRole',
            foreignKeyNamesOnServer: ['DefaultRoleId'],
            nameOnServer: 'DefaultRole',
            validators: []
          }
        ]
      },
      {
        shortName: 'OrganisationWorkspace',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'Workspaces',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'CapacityId', validators: [{ name: 'guid' }] },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'DeployStateUpdatedOn',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'EnforceAnyStandardRlsRoles',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 1000,
            nameOnServer: 'ModuleCodes',
            validators: [{ maxLength: 1000, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'OwnerId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 10,
            nameOnServer: 'Region',
            validators: [{ maxLength: 10, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'ServicePrincipalProfile',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'TemplateWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'WorkspaceQualifier',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'OrganisationPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationWorkspace_DataServicesGateway.Shared.Model.OrganisationPrincipal_Owner',
            foreignKeyNamesOnServer: ['OwnerId'],
            nameOnServer: 'Owner',
            validators: []
          },
          {
            entityTypeName: 'PbiOrganisationWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.PbiOrganisationWorkspace_DataServicesGateway.Shared.Model.OrganisationWorkspace_OrganisationWorkspace',
            invForeignKeyNamesOnServer: ['OrganisationWorkspaceId'],
            nameOnServer: 'PbiWorkspaces',
            validators: []
          },
          {
            entityTypeName: 'TemplateWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationWorkspace_DataServicesGateway.Shared.Model.TemplateWorkspace_TemplateWorkspace',
            foreignKeyNamesOnServer: ['TemplateWorkspaceId'],
            nameOnServer: 'TemplateWorkspace',
            validators: []
          }
        ]
      },
      {
        shortName: 'OrganisationWorkspaceDeployment',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'WorkspaceDeployments',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'DatasetDeploymentId', validators: [{ name: 'guid' }] },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'DeployStateUpdatedOn',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'OrganisationWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'PbiDeploymentId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'RevertedToId', validators: [{ name: 'guid' }] },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'RolledBackId', validators: [{ name: 'guid' }] },
          {
            dataType: 'String',
            enumType: 'OrganisationWorkspaceDeploymentStatus:#DataServicesGateway.Shared.Model',
            isNullable: false,
            maxLength: 50,
            nameOnServer: 'Status',
            validators: [{ name: 'required' }, { maxLength: 50, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'OrganisationWorkspaceDeployment:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_DatasetDeployment',
            foreignKeyNamesOnServer: ['DatasetDeploymentId'],
            nameOnServer: 'DatasetDeployment',
            validators: []
          },
          {
            entityTypeName: 'WorkspaceDeploymentFailure:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.WorkspaceDeploymentFailure_DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_WorkspaceDeployment',
            invForeignKeyNamesOnServer: ['WorkspaceDeploymentId'],
            nameOnServer: 'Failures',
            validators: []
          },
          {
            entityTypeName: 'OrganisationWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_DataServicesGateway.Shared.Model.OrganisationWorkspace_OrganisationWorkspace',
            foreignKeyNamesOnServer: ['OrganisationWorkspaceId'],
            nameOnServer: 'OrganisationWorkspace',
            validators: []
          },
          {
            entityTypeName: 'PbiDeployment:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_DataServicesGateway.Shared.Model.PbiDeployment_PbiDeployment',
            foreignKeyNamesOnServer: ['PbiDeploymentId'],
            nameOnServer: 'PbiDeployment',
            validators: []
          },
          {
            entityTypeName: 'OrganisationWorkspaceDeployment:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_RevertedTo',
            foreignKeyNamesOnServer: ['RevertedToId'],
            nameOnServer: 'RevertedTo',
            validators: []
          },
          {
            entityTypeName: 'OrganisationWorkspaceDeployment:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_RolledBack',
            foreignKeyNamesOnServer: ['RolledBackId'],
            nameOnServer: 'RolledBack',
            validators: []
          }
        ]
      },
      {
        shortName: 'OrganisationWorkspaceInfo',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'WorkspaceInfos',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'BackgroundColor',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'LongLabel',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'ShortLabel',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'TemplateWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'WorkspaceQualifier',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          }
        ],
        navigationProperties: []
      },
      {
        shortName: 'PbiDataset',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'PbiDatasets',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'DatasetId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'PbiWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'Dataset:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiDataset_DataServicesGateway.Shared.Model.Dataset_Dataset',
            foreignKeyNamesOnServer: ['DatasetId'],
            nameOnServer: 'Dataset',
            validators: []
          },
          {
            entityTypeName: 'PbiReport:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.PbiReport_DataServicesGateway.Shared.Model.PbiDataset_PbiDataset',
            invForeignKeyNamesOnServer: ['PbiDatasetId'],
            nameOnServer: 'PbiReports',
            validators: []
          },
          {
            entityTypeName: 'PbiOrganisationWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiDataset_DataServicesGateway.Shared.Model.PbiOrganisationWorkspace_PbiWorkspace',
            foreignKeyNamesOnServer: ['PbiWorkspaceId'],
            nameOnServer: 'PbiWorkspace',
            validators: []
          }
        ]
      },
      {
        shortName: 'PbiDatasetRefresh',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'PbiDatasetRefreshes',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'AttemptedAt',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'DataRefreshId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'DatasetId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'PbiDatasetId', validators: [{ name: 'guid' }] },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 200,
            nameOnServer: 'PbiDatasetNameAtAttempt',
            validators: [{ name: 'required' }, { maxLength: 200, name: 'maxLength' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'PbiRefreshId', validators: [{ name: 'guid' }] },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 50,
            nameOnServer: 'PbiRefreshStatus',
            validators: [{ maxLength: 50, name: 'maxLength' }]
          },
          { dataType: 'String', isNullable: true, nameOnServer: 'PbiServiceExceptionJson', validators: [] },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 200,
            nameOnServer: 'PbiWorkspaceNameAtAttempt',
            validators: [{ name: 'required' }, { maxLength: 200, name: 'maxLength' }]
          },
          { dataType: 'DateTime', isNullable: true, nameOnServer: 'SettledAt', validators: [{ name: 'date' }] },
          { dataType: 'DateTime', isNullable: true, nameOnServer: 'StartedAt', validators: [{ name: 'date' }] },
          {
            dataType: 'String',
            enumType: 'PbiDatasetRefreshStatus:#DataServicesGateway.Shared.Model',
            isNullable: false,
            maxLength: 50,
            nameOnServer: 'Status',
            validators: [{ name: 'required' }, { maxLength: 50, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            isPartOfKey: false,
            isNullable: false,
            complexTypeName: 'PbiRefreshMessage:#DataServicesGateway.Shared.Model',
            nameOnServer: 'PbiRefreshMessages',
            validators: []
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'DataRefresh:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiDatasetRefresh_DataServicesGateway.Shared.Model.DataRefresh_DataRefresh',
            foreignKeyNamesOnServer: ['DataRefreshId'],
            nameOnServer: 'DataRefresh',
            validators: []
          },
          {
            entityTypeName: 'Dataset:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiDatasetRefresh_DataServicesGateway.Shared.Model.Dataset_Dataset',
            foreignKeyNamesOnServer: ['DatasetId'],
            nameOnServer: 'Dataset',
            validators: []
          },
          {
            entityTypeName: 'PbiDataset:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiDatasetRefresh_DataServicesGateway.Shared.Model.PbiDataset_PbiDataset',
            foreignKeyNamesOnServer: ['PbiDatasetId'],
            nameOnServer: 'PbiDataset',
            validators: []
          }
        ]
      },
      {
        shortName: 'PbiDeployment',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'PbiDeployments',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 200,
            nameOnServer: 'OrchestratorInstanceId',
            validators: [{ maxLength: 200, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'RolledBackId', validators: [{ name: 'guid' }] },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            enumType: 'PbiDeploymentTrigger:#DataServicesGateway.Shared.Model',
            isNullable: false,
            maxLength: 50,
            nameOnServer: 'TriggerType',
            validators: [{ name: 'required' }, { maxLength: 50, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'PbiDeployment:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiDeployment_DataServicesGateway.Shared.Model.PbiDeployment_RolledBack',
            foreignKeyNamesOnServer: ['RolledBackId'],
            nameOnServer: 'RolledBack',
            validators: []
          },
          {
            entityTypeName: 'OrganisationWorkspaceDeployment:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_DataServicesGateway.Shared.Model.PbiDeployment_PbiDeployment',
            invForeignKeyNamesOnServer: ['PbiDeploymentId'],
            nameOnServer: 'WorkspaceDeployments',
            validators: []
          }
        ]
      },
      {
        shortName: 'PbiOrganisationWorkspace',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'PbiWorkspaces',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'DeploymentId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'OrganisationWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'PbiWorkspaceType',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Status',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'OrganisationWorkspaceDeployment:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiOrganisationWorkspace_DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_Deployment',
            foreignKeyNamesOnServer: ['DeploymentId'],
            nameOnServer: 'Deployment',
            validators: []
          },
          {
            entityTypeName: 'OrganisationWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiOrganisationWorkspace_DataServicesGateway.Shared.Model.OrganisationWorkspace_OrganisationWorkspace',
            foreignKeyNamesOnServer: ['OrganisationWorkspaceId'],
            nameOnServer: 'OrganisationWorkspace',
            validators: []
          },
          {
            entityTypeName: 'PbiReport:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.PbiReport_DataServicesGateway.Shared.Model.PbiOrganisationWorkspace_PbiWorkspace',
            invForeignKeyNamesOnServer: ['PbiWorkspaceId'],
            nameOnServer: 'PbiReports',
            validators: []
          }
        ]
      },
      {
        shortName: 'PbiReport',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'PbiReports',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'Description',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'EmbedUrl',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDraft',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'OwnerId', validators: [{ name: 'guid' }] },
          {
            dataType: 'Guid',
            isNullable: false,
            concurrencyMode: 'Fixed',
            nameOnServer: 'PbiDatasetId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'PbiWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'ReportId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'WebUrl',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiReport_DataServicesGateway.Shared.Model.IdentityPrincipal_Owner',
            foreignKeyNamesOnServer: ['OwnerId'],
            nameOnServer: 'Owner',
            validators: []
          },
          {
            entityTypeName: 'PbiDataset:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiReport_DataServicesGateway.Shared.Model.PbiDataset_PbiDataset',
            foreignKeyNamesOnServer: ['PbiDatasetId'],
            nameOnServer: 'PbiDataset',
            validators: []
          },
          {
            entityTypeName: 'PbiOrganisationWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiReport_DataServicesGateway.Shared.Model.PbiOrganisationWorkspace_PbiWorkspace',
            foreignKeyNamesOnServer: ['PbiWorkspaceId'],
            nameOnServer: 'PbiWorkspace',
            validators: []
          },
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.PbiReport_DataServicesGateway.Shared.Model.Report_Report',
            foreignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'Report',
            validators: []
          }
        ]
      },
      {
        shortName: 'RefreshFailureIssueLink',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'RefreshFailureIssueLinks',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedAt',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'DatasetId', validators: [{ name: 'guid' }] },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'DatasetIdSnapshot',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 200,
            nameOnServer: 'DatasetNameSnapshot',
            validators: [{ name: 'required' }, { maxLength: 200, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 100,
            nameOnServer: 'IssueNodeId',
            validators: [{ name: 'required' }, { maxLength: 100, name: 'maxLength' }]
          },
          {
            dataType: 'Int32',
            isNullable: false,
            nameOnServer: 'IssueNumber',
            validators: [{ name: 'required' }, { name: 'int32' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'PbiDatasetRefreshId', validators: [{ name: 'guid' }] },
          {
            dataType: 'DateTime',
            isNullable: true,
            concurrencyMode: 'Fixed',
            nameOnServer: 'RecoveredAt',
            validators: [{ name: 'date' }]
          },
          { dataType: 'DateTime', isNullable: true, nameOnServer: 'RetiredAt', validators: [{ name: 'date' }] },
          { dataType: 'DateTime', isNullable: true, nameOnServer: 'SupersededAt', validators: [{ name: 'date' }] },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 100,
            nameOnServer: 'TemplateWorkspaceNameSnapshot',
            validators: [{ name: 'required' }, { maxLength: 100, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 50,
            nameOnServer: 'WorkspaceQualifierSnapshot',
            validators: [{ name: 'required' }, { maxLength: 50, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'Dataset:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.RefreshFailureIssueLink_DataServicesGateway.Shared.Model.Dataset_Dataset',
            foreignKeyNamesOnServer: ['DatasetId'],
            nameOnServer: 'Dataset',
            validators: []
          },
          {
            entityTypeName: 'PbiDatasetRefresh:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.RefreshFailureIssueLink_DataServicesGateway.Shared.Model.PbiDatasetRefresh_PbiDatasetRefresh',
            foreignKeyNamesOnServer: ['PbiDatasetRefreshId'],
            nameOnServer: 'PbiDatasetRefresh',
            validators: []
          }
        ]
      },
      {
        shortName: 'Report',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'Reports',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'Category',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'DatasetId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'Description',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'EmbedUrl',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'HidesReportId', validators: [{ name: 'guid' }] },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsCustom',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDefault',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDeleted',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsEmbedOnly',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            concurrencyMode: 'Fixed',
            nameOnServer: 'IsPublished',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 4000,
            nameOnServer: 'LatestProblem',
            validators: [{ maxLength: 4000, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: true,
            nameOnServer: 'MinOverrideEmbedOnlyRoleId',
            validators: [{ name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'OrganisationWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'OwnerId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'ParentReportId', validators: [{ name: 'guid' }] },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'TemplateReportName',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'Int32',
            isNullable: false,
            nameOnServer: 'Version',
            validators: [{ name: 'required' }, { name: 'int32' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'WebUrl',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'ReportActivityRecord:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.ReportActivityRecord_DataServicesGateway.Shared.Model.Report_Report',
            invForeignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'ActivityRecords',
            validators: []
          },
          {
            entityTypeName: 'ReportAccess:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.ReportAccess_DataServicesGateway.Shared.Model.Report_Target',
            invForeignKeyNamesOnServer: ['TargetId'],
            nameOnServer: 'AllowedPrincipals',
            validators: []
          },
          {
            entityTypeName: 'Bookmark:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName: 'DataServicesGateway.Shared.Model.Bookmark_DataServicesGateway.Shared.Model.Report_Report',
            invForeignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'Bookmarks',
            validators: []
          },
          {
            entityTypeName: 'Dataset:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName: 'DataServicesGateway.Shared.Model.Report_DataServicesGateway.Shared.Model.Dataset_Dataset',
            foreignKeyNamesOnServer: ['DatasetId'],
            nameOnServer: 'Dataset',
            validators: []
          },
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.Report_DataServicesGateway.Shared.Model.Report_HidesReport',
            foreignKeyNamesOnServer: ['HidesReportId'],
            nameOnServer: 'HidesReport',
            validators: []
          },
          {
            entityTypeName: 'Role:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.Report_DataServicesGateway.Shared.Model.Role_MinOverrideEmbedOnlyRole',
            foreignKeyNamesOnServer: ['MinOverrideEmbedOnlyRoleId'],
            nameOnServer: 'MinOverrideEmbedOnlyRole',
            validators: []
          },
          {
            entityTypeName: 'OrganisationWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.Report_DataServicesGateway.Shared.Model.OrganisationWorkspace_OrganisationWorkspace',
            foreignKeyNamesOnServer: ['OrganisationWorkspaceId'],
            nameOnServer: 'OrganisationWorkspace',
            validators: []
          },
          {
            entityTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.Report_DataServicesGateway.Shared.Model.IdentityPrincipal_Owner',
            foreignKeyNamesOnServer: ['OwnerId'],
            nameOnServer: 'Owner',
            validators: []
          },
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.Report_DataServicesGateway.Shared.Model.Report_ParentReport',
            foreignKeyNamesOnServer: ['ParentReportId'],
            nameOnServer: 'ParentReport',
            validators: []
          },
          {
            entityTypeName: 'PbiReport:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.PbiReport_DataServicesGateway.Shared.Model.Report_Report',
            invForeignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'PbiReports',
            validators: []
          },
          {
            entityTypeName: 'ReportUserPreference:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.ReportUserPreference_DataServicesGateway.Shared.Model.Report_Report',
            invForeignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'UserPreferences',
            validators: []
          }
        ]
      },
      {
        shortName: 'ReportAccess',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'ReportAccesses',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'TargetId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'IdentityPrincipalId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportAccess_DataServicesGateway.Shared.Model.IdentityPrincipal_IdentityPrincipal',
            foreignKeyNamesOnServer: ['IdentityPrincipalId'],
            nameOnServer: 'IdentityPrincipal',
            validators: []
          },
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportAccess_DataServicesGateway.Shared.Model.Report_Target',
            foreignKeyNamesOnServer: ['TargetId'],
            nameOnServer: 'Target',
            validators: []
          }
        ]
      },
      {
        shortName: 'ReportActivityRecord',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'ReportActivityRecords',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'ActivityDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            enumType: 'ReportActivityType:#DataServicesGateway.Shared.Model',
            isNullable: false,
            nameOnServer: 'ActivityType',
            validators: [{ name: 'required' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'DraftId', validators: [{ name: 'guid' }] },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'DraftName',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'ReportId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'UserId', validators: [{ name: 'guid' }] }
        ],
        navigationProperties: [
          {
            entityTypeName: 'PbiReport:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportActivityRecord_DataServicesGateway.Shared.Model.PbiReport_Draft',
            foreignKeyNamesOnServer: ['DraftId'],
            nameOnServer: 'Draft',
            validators: []
          },
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportActivityRecord_DataServicesGateway.Shared.Model.Report_Report',
            foreignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'Report',
            validators: []
          },
          {
            entityTypeName: 'UserPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportActivityRecord_DataServicesGateway.Shared.Model.UserPrincipal_User',
            foreignKeyNamesOnServer: ['UserId'],
            nameOnServer: 'User',
            validators: []
          }
        ]
      },
      {
        shortName: 'ReportActivityRecordInfo',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'ReportActivityRecordInfos',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'ActivityDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            enumType: 'ReportActivityType:#DataServicesGateway.Shared.Model',
            isNullable: false,
            nameOnServer: 'ActivityType',
            validators: [{ name: 'required' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'DraftId', validators: [{ name: 'guid' }] },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'DraftName',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'Email',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'ReportId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'UserFullName',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'UserId', validators: [{ name: 'guid' }] },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'UserTeam',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'PbiReport:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportActivityRecordInfo_DataServicesGateway.Shared.Model.PbiReport_Draft',
            foreignKeyNamesOnServer: ['DraftId'],
            nameOnServer: 'Draft',
            validators: []
          },
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportActivityRecordInfo_DataServicesGateway.Shared.Model.Report_Report',
            foreignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'Report',
            validators: []
          }
        ]
      },
      {
        shortName: 'ReportInfo',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          { dataType: 'String', isNullable: true, nameOnServer: 'Category', validators: [] },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'DatasetId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          { dataType: 'String', isNullable: false, nameOnServer: 'DatasetName', validators: [{ name: 'required' }] },
          { dataType: 'String', isNullable: true, nameOnServer: 'Description', validators: [] },
          { dataType: 'String', isNullable: false, nameOnServer: 'EmbedUrl', validators: [{ name: 'required' }] },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'HiddenById', validators: [{ name: 'guid' }] },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'HidesReportId', validators: [{ name: 'guid' }] },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsCustom',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDefault',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsEmbedOnly',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsFavorite',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsPublished',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          { dataType: 'DateTime', isNullable: true, nameOnServer: 'LastViewed', validators: [{ name: 'date' }] },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 4000,
            nameOnServer: 'LatestProblem',
            validators: [{ maxLength: 4000, name: 'maxLength' }]
          },
          { dataType: 'String', isNullable: false, nameOnServer: 'Name', validators: [{ name: 'required' }] },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'OrganisationWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'OwnerId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          { dataType: 'Guid', isNullable: true, nameOnServer: 'ParentReportId', validators: [{ name: 'guid' }] },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'PbiDatasetId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'PbiReportId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'PbiWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          { dataType: 'String', isNullable: true, nameOnServer: 'TemplateReportName', validators: [] },
          {
            dataType: 'Int32',
            isNullable: false,
            nameOnServer: 'Version',
            validators: [{ name: 'required' }, { name: 'int32' }]
          },
          { dataType: 'String', isNullable: false, nameOnServer: 'WebUrl', validators: [{ name: 'required' }] }
        ],
        navigationProperties: [
          {
            entityTypeName: 'OrganisationWorkspaceInfo:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportInfo_DataServicesGateway.Shared.Model.OrganisationWorkspaceInfo_OrganisationWorkspace',
            foreignKeyNamesOnServer: ['OrganisationWorkspaceId'],
            nameOnServer: 'OrganisationWorkspace',
            validators: []
          }
        ]
      },
      {
        shortName: 'ReportUserPreference',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'ReportUserPreferences',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'UserId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'ReportId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsDefault',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsFavorite',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'Report:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportUserPreference_DataServicesGateway.Shared.Model.Report_Report',
            foreignKeyNamesOnServer: ['ReportId'],
            nameOnServer: 'Report',
            validators: []
          },
          {
            entityTypeName: 'UserPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ReportUserPreference_DataServicesGateway.Shared.Model.UserPrincipal_User',
            foreignKeyNamesOnServer: ['UserId'],
            nameOnServer: 'User',
            validators: []
          }
        ]
      },
      {
        shortName: 'Role',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'Roles',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Description',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsActive',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsBuiltIn',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsGlobal',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsPbiAccessAssigned',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsServicePrincipalOnly',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 100,
            nameOnServer: 'SecurityGroupId',
            validators: [{ maxLength: 100, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 50,
            nameOnServer: 'SecurityGroupType',
            validators: [{ maxLength: 50, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: []
      },
      {
        shortName: 'RoleAccess',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'RoleAccesses',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'TargetRoleId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'RoleId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isPartOfKey: true,
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'Role:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName: 'DataServicesGateway.Shared.Model.RoleAccess_DataServicesGateway.Shared.Model.Role_Role',
            foreignKeyNamesOnServer: ['RoleId'],
            nameOnServer: 'Role',
            validators: []
          },
          {
            entityTypeName: 'Role:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.RoleAccess_DataServicesGateway.Shared.Model.Role_TargetRole',
            foreignKeyNamesOnServer: ['TargetRoleId'],
            nameOnServer: 'TargetRole',
            validators: []
          }
        ]
      },
      {
        shortName: 'SQLCache',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'String',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }]
          },
          {
            dataType: 'DateTimeOffset',
            isNullable: true,
            nameOnServer: 'AbsoluteExpiration',
            validators: [{ name: 'date' }]
          },
          {
            dataType: 'DateTimeOffset',
            isNullable: false,
            nameOnServer: 'ExpiresAtTime',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'Int64',
            isNullable: true,
            nameOnServer: 'SlidingExpirationInSeconds',
            validators: [{ name: 'int64' }]
          },
          { dataType: 'Binary', isNullable: false, nameOnServer: 'Value', validators: [{ name: 'required' }] }
        ],
        navigationProperties: []
      },
      {
        shortName: 'ServicePrincipal',
        namespace: 'DataServicesGateway.Shared.Model',
        baseTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'ServicePrincipals',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'CanAccessAllTenants',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'IdentityProviderClientId',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'ServicePrincipalRole:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.ServicePrincipalRole_DataServicesGateway.Shared.Model.ServicePrincipal_ServicePrincipal',
            invForeignKeyNamesOnServer: ['ServicePrincipalId'],
            nameOnServer: 'Roles',
            validators: []
          }
        ]
      },
      {
        shortName: 'ServicePrincipalRole',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'RoleId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'ServicePrincipalId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'Role:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ServicePrincipalRole_DataServicesGateway.Shared.Model.Role_Role',
            foreignKeyNamesOnServer: ['RoleId'],
            nameOnServer: 'Role',
            validators: []
          },
          {
            entityTypeName: 'ServicePrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.ServicePrincipalRole_DataServicesGateway.Shared.Model.ServicePrincipal_ServicePrincipal',
            foreignKeyNamesOnServer: ['ServicePrincipalId'],
            nameOnServer: 'ServicePrincipal',
            validators: []
          }
        ]
      },
      {
        shortName: 'TemplateWorkspace',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'TemplateWorkspaces',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: true,
            nameOnServer: 'AuthorizedServicePrincipalId',
            validators: [{ name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'BackgroundColor',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: true,
            maxLength: 500,
            nameOnServer: 'LongLabel',
            validators: [{ maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Name',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'ProductNameOrFamily',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 5,
            nameOnServer: 'ShortLabel',
            validators: [{ name: 'required' }, { maxLength: 5, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'TemplatePbiWorkspaceName',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'ServicePrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.TemplateWorkspace_DataServicesGateway.Shared.Model.ServicePrincipal_AuthorizedServicePrincipal',
            foreignKeyNamesOnServer: ['AuthorizedServicePrincipalId'],
            nameOnServer: 'AuthorizedServicePrincipal',
            validators: []
          },
          {
            entityTypeName: 'TemplateWorkspaceTargetSettings:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.TemplateWorkspaceTargetSettings_DataServicesGateway.Shared.Model.TemplateWorkspace_TemplateWorkspace',
            invForeignKeyNamesOnServer: ['TemplateWorkspaceId'],
            nameOnServer: 'TargetSettings',
            validators: []
          }
        ]
      },
      {
        shortName: 'TemplateWorkspaceTargetSettings',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'TemplateWorkspaceTargetSettings',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'TemplateWorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isPartOfKey: true,
            isNullable: false,
            maxLength: 10,
            nameOnServer: 'Region',
            validators: [{ name: 'required' }, { maxLength: 10, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'CapacityId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'GatewayId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsRegionNeutralFallback',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'TemplateWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.TemplateWorkspaceTargetSettings_DataServicesGateway.Shared.Model.TemplateWorkspace_TemplateWorkspace',
            foreignKeyNamesOnServer: ['TemplateWorkspaceId'],
            nameOnServer: 'TemplateWorkspace',
            validators: []
          }
        ]
      },
      {
        shortName: 'UserPrincipal',
        namespace: 'DataServicesGateway.Shared.Model',
        baseTypeName: 'IdentityPrincipal:#DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'Users',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'Email',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'FirstName',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'IdentityProviderUserId',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 500,
            nameOnServer: 'LastName',
            validators: [{ name: 'required' }, { maxLength: 500, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'OrganisationMembership:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.OrganisationMembership_DataServicesGateway.Shared.Model.UserPrincipal_User',
            invForeignKeyNamesOnServer: ['UserId'],
            nameOnServer: 'Organisations',
            validators: []
          },
          {
            entityTypeName: 'UserRole:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.UserRole_DataServicesGateway.Shared.Model.UserPrincipal_User',
            invForeignKeyNamesOnServer: ['UserId'],
            nameOnServer: 'UserRoles',
            validators: []
          }
        ]
      },
      {
        shortName: 'UserReportFilter',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'Identity',
        defaultResourceName: 'UserReportFilters',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'Id',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'ExcludeUnassigned',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'ExcludeUnpublished',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'Guid',
            isNullable: false,
            nameOnServer: 'UserId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'UserReportWorkspaceFilter:#DataServicesGateway.Shared.Model',
            isScalar: false,
            associationName:
              'DataServicesGateway.Shared.Model.UserReportWorkspaceFilter_DataServicesGateway.Shared.Model.UserReportFilter_UserReportFilter',
            invForeignKeyNamesOnServer: ['UserId', 'TenantKey'],
            nameOnServer: 'ExcludedWorkspaces',
            validators: []
          },
          {
            entityTypeName: 'OrganisationMembership:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.UserReportFilter_DataServicesGateway.Shared.Model.OrganisationMembership_OrganisationMembership',
            foreignKeyNamesOnServer: ['UserId', 'TenantKey'],
            invForeignKeyNamesOnServer: ['UserId', 'TenantKey'],
            nameOnServer: 'OrganisationMembership',
            validators: []
          }
        ]
      },
      {
        shortName: 'UserReportWorkspaceFilter',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'UserReportWorkspaceFilters',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'UserId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'WorkspaceId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'UserReportFilter:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.UserReportWorkspaceFilter_DataServicesGateway.Shared.Model.UserReportFilter_UserReportFilter',
            foreignKeyNamesOnServer: ['UserId', 'TenantKey'],
            invForeignKeyNamesOnServer: ['UserId', 'TenantKey'],
            nameOnServer: 'UserReportFilter',
            validators: []
          },
          {
            entityTypeName: 'OrganisationWorkspace:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.UserReportWorkspaceFilter_DataServicesGateway.Shared.Model.OrganisationWorkspace_Workspace',
            foreignKeyNamesOnServer: ['WorkspaceId'],
            nameOnServer: 'Workspace',
            validators: []
          }
        ]
      },
      {
        shortName: 'UserRole',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        defaultResourceName: 'UserRoles',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'RoleId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'UserId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isPartOfKey: true,
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'Boolean',
            isNullable: false,
            nameOnServer: 'IsSecurityGroupAssigned',
            validators: [{ name: 'required' }, { name: 'bool' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 150,
            nameOnServer: 'LastUpdatedBy',
            validators: [{ name: 'required' }, { maxLength: 150, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'LastUpdatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodEnd',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'PeriodStart',
            validators: [{ name: 'required' }, { name: 'date' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'Role:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName: 'DataServicesGateway.Shared.Model.UserRole_DataServicesGateway.Shared.Model.Role_Role',
            foreignKeyNamesOnServer: ['RoleId'],
            nameOnServer: 'Role',
            validators: []
          },
          {
            entityTypeName: 'UserPrincipal:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.UserRole_DataServicesGateway.Shared.Model.UserPrincipal_User',
            foreignKeyNamesOnServer: ['UserId'],
            nameOnServer: 'User',
            validators: []
          }
        ]
      },
      {
        shortName: 'WorkspaceDeploymentFailure',
        namespace: 'DataServicesGateway.Shared.Model',
        autoGeneratedKeyType: 'None',
        isComplexType: false,
        dataProperties: [
          {
            dataType: 'Guid',
            isPartOfKey: true,
            isNullable: false,
            nameOnServer: 'WorkspaceDeploymentId',
            validators: [{ name: 'required' }, { name: 'guid' }]
          },
          {
            dataType: 'String',
            isPartOfKey: true,
            isNullable: false,
            maxLength: 200,
            nameOnServer: 'Message',
            validators: [{ name: 'required' }, { maxLength: 200, name: 'maxLength' }]
          },
          {
            dataType: 'DateTime',
            isNullable: false,
            nameOnServer: 'CreatedDate',
            validators: [{ name: 'required' }, { name: 'date' }]
          },
          {
            dataType: 'String',
            enumType: 'DeploymentFailureSeverity:#DataServicesGateway.Shared.Model',
            isNullable: false,
            maxLength: 50,
            nameOnServer: 'Severity',
            validators: [{ name: 'required' }, { maxLength: 50, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            isNullable: false,
            maxLength: 36,
            concurrencyMode: 'Fixed',
            nameOnServer: 'TenantKey',
            validators: [{ name: 'required' }, { maxLength: 36, name: 'maxLength' }]
          },
          {
            dataType: 'String',
            enumType: 'DeploymentFailureType:#DataServicesGateway.Shared.Model',
            isNullable: false,
            maxLength: 50,
            nameOnServer: 'Type',
            validators: [{ name: 'required' }, { maxLength: 50, name: 'maxLength' }]
          }
        ],
        navigationProperties: [
          {
            entityTypeName: 'OrganisationWorkspaceDeployment:#DataServicesGateway.Shared.Model',
            isScalar: true,
            associationName:
              'DataServicesGateway.Shared.Model.WorkspaceDeploymentFailure_DataServicesGateway.Shared.Model.OrganisationWorkspaceDeployment_WorkspaceDeployment',
            foreignKeyNamesOnServer: ['WorkspaceDeploymentId'],
            nameOnServer: 'WorkspaceDeployment',
            validators: []
          }
        ]
      }
    ],
    enumTypes: [
      {
        shortName: 'DataRefreshStatus',
        namespace: 'DataServicesGateway.Shared.Model',
        values: ['Pending', 'InProgress', 'Success', 'MixedOutcome', 'Failed', 'TimedOut'],
        ordinals: ['Pending', 'InProgress', 'Success', 'MixedOutcome', 'Failed', 'TimedOut']
      },
      {
        shortName: 'DataRefreshTriggerSource',
        namespace: 'DataServicesGateway.Shared.Model',
        values: ['EndpointRequest', 'Deployment'],
        ordinals: ['EndpointRequest', 'Deployment']
      },
      {
        shortName: 'OrganisationWorkspaceDeploymentStatus',
        namespace: 'DataServicesGateway.Shared.Model',
        values: [
          'Pending',
          'InProgress',
          'Completed',
          'Failed',
          'Cancelled',
          'RequiresRefresh',
          'Aborted',
          'RolledBack',
          'RefreshFailed',
          'RefreshAborted'
        ],
        ordinals: [
          'Pending',
          'InProgress',
          'Completed',
          'Failed',
          'Cancelled',
          'RequiresRefresh',
          'Aborted',
          'RolledBack',
          'RefreshFailed',
          'RefreshAborted'
        ]
      },
      {
        shortName: 'PbiDatasetRefreshStatus',
        namespace: 'DataServicesGateway.Shared.Model',
        values: [
          'Pending',
          'Running',
          'Completed',
          'Failed',
          'Cancelled',
          'SkippedAlreadyInProgress',
          'SkippedNotRefreshable',
          'SubmissionFailed',
          'TimedOut'
        ],
        ordinals: [
          'Pending',
          'Running',
          'Completed',
          'Failed',
          'Cancelled',
          'SkippedAlreadyInProgress',
          'SkippedNotRefreshable',
          'SubmissionFailed',
          'TimedOut'
        ]
      },
      {
        shortName: 'PbiDeploymentTrigger',
        namespace: 'DataServicesGateway.Shared.Model',
        values: ['Default', 'ClientUpdate', 'SourceControl', 'Seed', 'Rollback', 'MultiClientDeployment'],
        ordinals: ['Default', 'ClientUpdate', 'SourceControl', 'Seed', 'Rollback', 'MultiClientDeployment']
      },
      {
        shortName: 'ReportActivityType',
        namespace: 'DataServicesGateway.Shared.Model',
        values: ['View', 'SaveDraft', 'ImportDraft', 'DownloadDraft', 'Publish'],
        ordinals: ['View', 'SaveDraft', 'ImportDraft', 'DownloadDraft', 'Publish']
      },
      {
        shortName: 'DeploymentFailureSeverity',
        namespace: 'DataServicesGateway.Shared.Model',
        values: ['Error', 'Warning'],
        ordinals: ['Error', 'Warning']
      },
      {
        shortName: 'DeploymentFailureType',
        namespace: 'DataServicesGateway.Shared.Model',
        values: ['Rollback', 'RollbackValidation', 'Deployment'],
        ordinals: ['Rollback', 'RollbackValidation', 'Deployment']
      }
    ]
  };
}
